import { Component } from "@angular/core";
import { TranslateService } from "../translate";

@Component({
	selector: "sdp-footer",
	templateUrl: "./footer.component.html"
})
export class FooterComponent {
	public footerMessage = "";

	constructor(
		translateService: TranslateService
	) {
		this.footerMessage = `&copy; ${new Date().getFullYear()} ${translateService.translate("footer.copyright")}`;
	}

}
